// Mock data for Janvi Rathod Portfolio

export const personalInfo = {
  name: "Janvi Rathod",
  title: "Web Developer Team Lead & Client Coordinator",
  location: "India",
  email: "janvirathod9802@gmail.com",
  // phone: "+91-77780 76223",
  bio: "Confident Web Developer Team Lead with experience in React, NextJS, Java, and Spring Boot. Skilled in client coordination, team leadership, and delivering scalable web applications. Passionate about building impactful digital solutions.",
  avatar: "https://images.unsplash.com/photo-1629507313712-f21468afdf2e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwyfHxwcm9mZXNzaW9uYWwlMjBidXNpbmVzcyUyMHBvcnRyYWl0fGVufDB8fHx8MTc3MTQ3Njg0NHww&ixlib=rb-4.1.0&q=85"
};

export const experiences = [
  {
    id: 1,
    company: "Dotcom Webs Pvt. Ltd.",
    role: "Web Developer Team Lead & Client Coordinator",
    duration: "May 2025 – Present",
    description: "Leading a team of developers, coordinating with clients, managing project timelines, and ensuring delivery of high-quality web solutions. Implementing modern tech stacks and best practices.",
    current: true
  },
  {
    id: 2,
    company: "Ecare Infoway LLP",
    role: "Technical Trainer and Counselor",
    duration: "Nov 2024 – May 2025",
    description: "Trained aspiring developers in web technologies including React, Java, and Spring Boot. Provided career guidance and technical mentorship to students.",
    current: false
  },
  {
    id: 3,
    company: "Rishabh Software Pvt. Ltd.",
    role: "Trainee",
    duration: "Jan 2024 – Oct 2024",
    description: "Worked on full-stack development projects using React, Spring Boot, and MongoDB. Gained hands-on experience in agile development and team collaboration.",
    current: false
  },
  {
    id: 4,
    company: "DND Software Pvt. Ltd.",
    role: "Software Engineer",
    duration: "May 2022 – Aug 2023",
    description: "Developed and maintained web applications using modern frameworks. Collaborated with cross-functional teams to deliver client projects successfully.",
    current: false
  }
];

export const education = {
  degree: "Bachelor of Computer Applications (BCA)",
  university: "Saurashtra University",
  cgpa: "8.28 CGPA",
  year: "2022"
};

export const skills = {
  frontend: [
    { name: "ReactJS", level: 90 },
    { name: "NextJS", level: 85 },
    { name: "HTML5", level: 95 },
    { name: "CSS3", level: 90 },
    { name: "JavaScript", level: 90 },
    { name: "Redux", level: 80 },
    { name: "WordPress", level: 85 }
  ],
  backend: [
    { name: "Java", level: 85 },
    { name: "Spring Boot", level: 80 },
    { name: "Hibernate", level: 75 },
    { name: "JPA", level: 75 },
    { name: "NodeJS", level: 80 }
  ],
  database: [
    { name: "MySQL", level: 85 },
    { name: "MSSQL", level: 80 },
    { name: "MongoDB", level: 85 }
  ],
  tools: [
    { name: "VS Code", level: 95 },
    { name: "IntelliJ IDEA", level: 85 },
    { name: "GitHub", level: 90 },
    { name: "MongoDB Atlas", level: 85 }
  ]
};

export const projects = [
  {
    id: 1,
    title: "E-Commerce Platform",
    description: "Full-featured e-commerce platform with product management, cart functionality, payment integration, and order tracking. Built with modern technologies for scalability.",
    image: "https://images.unsplash.com/photo-1658297063569-162817482fb6",
    techStack: ["React", "NodeJS", "MongoDB", "Redux", "Stripe"],
    github: "https://github.com",
    demo: "https://demo.com"
  },
  {
    id: 2,
    title: "Corporate Website",
    description: "Modern, responsive corporate website with SEO optimization, dynamic content management, and interactive UI. Server-side rendered for optimal performance.",
    image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f",
    techStack: ["NextJS", "React", "TailwindCSS", "Framer Motion"],
    github: "https://github.com",
    demo: "https://demo.com"
  },
  {
    id: 3,
    title: "Admin Dashboard",
    description: "Comprehensive admin dashboard with real-time analytics, user management, and data visualization. Features role-based access control and secure authentication.",
    image: "https://images.pexels.com/photos/10020092/pexels-photo-10020092.jpeg",
    techStack: ["Spring Boot", "React", "MySQL", "Chart.js", "JWT"],
    github: "https://github.com",
    demo: "https://demo.com"
  },
  {
    id: 4,
    title: "WordPress Business Site",
    description: "Professional WordPress website with custom theme development, plugin integration, and optimized performance. Includes blog, contact forms, and SEO features.",
    image: "https://images.unsplash.com/photo-1487014679447-9f8336841d58",
    techStack: ["WordPress", "PHP", "MySQL", "JavaScript", "CSS3"],
    github: "https://github.com",
    demo: "https://demo.com"
  }
];

export const achievements = [
  {
    id: 1,
    title: "Team Leadership",
    description: "Successfully leading a team of developers at Dotcom Webs, managing multiple client projects simultaneously."
  },
  {
    id: 2,
    title: "Technical Trainer",
    description: "Trained and mentored 50+ students in web development technologies at Ecare Infoway LLP."
  },
  {
    id: 3,
    title: "MongoDB Certification",
    description: "Completed MongoDB certification course on Udemy with hands-on project experience."
  },
  {
    id: 4,
    title: "C Programming Competition",
    description: "Participated in competitive programming events, demonstrating strong problem-solving skills."
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Priya Sharma",
    role: "Project Manager, Tech Solutions Inc.",
    image: "https://images.unsplash.com/photo-1629507313712-f21468afdf2e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwyfHxwcm9mZXNzaW9uYWwlMjBidXNpbmVzcyUyMHBvcnRyYWl0fGVufDB8fHx8MTc3MTQ3Njg0NHww&ixlib=rb-4.1.0&q=85",
    text: "Janvi is an exceptional team lead who combines technical expertise with excellent communication skills. She delivered our project ahead of schedule and exceeded expectations."
  },
  {
    id: 2,
    name: "Rahul Mehta",
    role: "CEO, Digital Innovations",
    image: "https://images.unsplash.com/photo-1581065178047-8ee15951ede6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHw0fHxwcm9mZXNzaW9uYWwlMjBidXNpbmVzcyUyMHBvcnRyYWl0fGVufDB8fHx8MTc3MTQ3Njg0NHww&ixlib=rb-4.1.0&q=85",
    text: "Working with Janvi was a pleasure. Her ability to understand client requirements and translate them into technical solutions is remarkable. Highly recommended!"
  },
  {
    id: 3,
    name: "Ayesha Khan",
    role: "Technical Director, WebCraft Studios",
    image: "https://images.pexels.com/photos/33871730/pexels-photo-33871730.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    text: "Janvi's leadership and technical skills are top-notch. She mentored our junior developers and significantly improved our team's productivity and code quality."
  }
];